import { Button, type ButtonProps } from '~/components/button'

interface ModalClosableButtonProps
  extends Omit<ButtonProps, 'size' | 'variant' | 'onClick'> {
  onClick?: () => void
}

export function ModalClosableButton({
  onClick,
  ...rest
}: ModalClosableButtonProps) {
  return (
    <Button.Root
      {...rest}
      variant="neutral-tertiary"
      size="lg"
      onClick={onClick}
      data-testid={rest.id}
    >
      <Button.Icon symbol="rdicon-dismiss" />
    </Button.Root>
  )
}
